// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__7KjB7","question":"Question_question__2RFfj","description":"Question_description__2gCRt"};